import React, { useState, useEffect, useRef } from "react";
import Swal from "sweetalert2";
import { Card, Form, Button, Modal } from "react-bootstrap";
import { decodeToken } from "react-jwt";
import "../../App.css";
import axios from "axios";
import MessageTimeline from "./messageTimeline";

export default function LoggedIn(props) {
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const target = useRef(null);
  const [userData, setUserData] = useState("");
  const [name, setName] = useState("");
  const [id, setId] = useState("");
  const [pin, setPin] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);

  useEffect(() => {
    const token = localStorage.getItem("userToken");
    if (token) {
      const decoded = decodeToken(token);
      setName(decoded.name);
      setId(decoded.id);
      setPin(decoded.pin);
    }
  });

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  function deleteAccount() {
    axios
      .post("https://secretsafe-backend.onrender.com/delete-account", {
        id,
        pin,
      })
      .then((response, err) => {
        if (err) {
        } else {
          if (response.data.response) {
            localStorage.removeItem("userToken");
            window.location.reload();
          }
        }
      });
  }

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Take A Screenshot Of This!!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <b>
            ID: {id} <br /> PIN: {pin}
          </b>
          <br />
          <a href="https://secretsafe.rf.gd" style={{ textDecoration: "none" }}>
            https://secretsafe.rf.gd
          </a>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            Done
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={show2} onHide={handleClose2}>
        <Modal.Header closeButton>
          <Modal.Title>Settings</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Delete your account permanently.
          <br />
          After clicking delete account button, your data will be deleted from
          our servers.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose2}>
            Close
          </Button>
          <Button variant="danger" onClick={() => deleteAccount()}>
            Delete Account
          </Button>
        </Modal.Footer>
      </Modal>
      <Card
        style={{ alignItems: "center", padding: "15px", marginTop: "20px" }}
        className="mx-auto card__"
      >
        <Card.Body
          style={{ fontWeight: "900", fontSize: "35px", textAlign: "center" }}
        >
          Share this link everywhere.
        </Card.Body>
        <Card.Body
          style={{
            fontSize: "16px",
            textAlign: "center",
            paddingTop: "5px",
            paddingBottom: "2px",
          }}
        >
          Share this link on all of your social media accounts
        </Card.Body>
        <Card.Body
          style={{
            fontWeight: "900",
            textAlign: "center",
            fontSize: "18px",
            paddingTop: "2px",
          }}
        >
          Leaderboard will be shown down below. [Scroll Down]
        </Card.Body>
        <Form.Control
          value={props.link}
          placeholder={props.link}
          disabled
          style={{
            marginLeft: "40px",
            marginRight: "40px",
            border: "3px #7F7CAF solid",
            textAlign: "center",
          }}
        />
        <Button
          style={{
            marginLeft: "40px",
            marginRight: "40px",
            width: "100%",
            marginTop: "5px",
            fontWeight: "500",
          }}
          variant="secondary"
          onClick={() => {
            navigator.clipboard.writeText(props.link).then(() =>
              Toast.fire({
                icon: "success",
                title: "Message copied successfully",
              }),
            );
          }}
        >
          Click to Copy
        </Button>
        <Button
          style={{
            marginLeft: "40px",
            marginRight: "40px",
            width: "100%",
            marginTop: "5px",
          }}
          href={
            "whatsapp://send?text=%E2%9C%89%EF%B8%8F%F0%9F%92%AC%F0%9F%92%8C%0D%0ASend+Secret+Message+to+%2A" +
            name +
            "%2A%0D%0A%F0%9F%A4%A9+I+will+never+know+who+sent+me+which+message+%F0%9F%A4%94%0D%0AIt%27s+fun%2C+Try+here+%F0%9F%91%89+" +
            props.link
          }
          variant="success"
        >
          Add to Story ( WhatsApp )
        </Button>
        <Button
          style={{
            marginLeft: "40px",
            marginRight: "40px",
            width: "100%",
            marginTop: "5px",
          }}
          href={
            "https://www.addtoany.com/add_to/facebook?linkurl=https%3A%2F%2F" +
            props.link +
            "&amp;linkname=SecretSafe"
          }
          variant="primary"
        >
          Share ( FaceBook )
        </Button>
        <Button
          style={{
            marginLeft: "40px",
            marginRight: "40px",
            width: "50%",
            marginTop: "5px",
          }}
          onClick={() => handleShow()}
          variant="danger"
        >
          View Login Details
        </Button>
        <Button
          style={{
            marginLeft: "40px",
            marginRight: "40px",
            width: "50%",
            marginTop: "5px",
          }}
          onClick={() => handleShow2()}
          variant="secondary"
        >
          Settings
        </Button>
      </Card>
      <MessageTimeline />
    </>
  );
}
